.number {
  flex: 1;
}

.texts {
  flex: 16;
  position: relative;
}

.option {
  display: flex;
  align-items: center;

  & .number,
  & .texts {
    min-height: 2.5em;
  }
}

.optionHeader {
  width: 100%;
  text-align: right;
}

.emptyOption {
  opacity: 0.3;
}

.editButton {
  color: var(--blue);
  margin: 0;
  border: 0;
  background: transparent;
  font-size: 1.5em;
  position: absolute;
  right: 0;
  top: -0.5em;
}

.openEditor {
  align-items: flex-start;
}

.editorLabel {
  position: relative;
  top: 1.5em;
}

.buttonContainer {
  margin-top: 1em;
}

.closedQuestion {
  margin-top: 2em;
  margin-bottom: 2em;
}

.value {
  display: inline-block;
  width: 5em;
  margin-left: 1em;

  & input {
    width: 100%;
    background: var(--white);
    border: 1px solid var(--darkSilver);
    color: var(--gray);
    outline: none;
    padding: 10px;
  }
}
